var map = {
	"./Rectangle.svg": "ddc4",
	"./about-1.jpg": "f8d7",
	"./about-2.jpg": "59ce",
	"./about-3.jpg": "4123",
	"./about_community.svg": "57e5",
	"./about_history.svg": "7799",
	"./about_mind.svg": "0f23",
	"./about_oblivion.svg": "08f4",
	"./about_something_new.svg": "e658",
	"./add_book.png": "46ca",
	"./add_new_books.png": "7659",
	"./add_new_books_hover.png": "cd63",
	"./add_new_books_view.png": "a18d",
	"./add_review.png": "cedc",
	"./add_review.svg": "1b36",
	"./alert.png": "95e1",
	"./arrow.svg": "1106",
	"./badge-founder.png": "868f",
	"./banner_big.png": "2475",
	"./banner_books.jpg": "b825",
	"./banner_landing.jpg": "7179",
	"./banner_landing.png": "91d6",
	"./banner_landing_1.jpg": "bb7c",
	"./banner_light_theme.jpg": "cb545",
	"./banner_small.png": "10ae",
	"./bell_notification.png": "3137",
	"./book.jpg": "c274",
	"./book_1.png": "ef46",
	"./books_icon.svg": "a3c3",
	"./catalogued_until_now.jpg": "23e4",
	"./contact.jpg": "4e8b",
	"./contact.png": "d73d",
	"./contact_us.jpg": "94d6",
	"./default-book.jpg": "f4da",
	"./default-book.png": "0092",
	"./feeling_lucky.jpg": "bc33",
	"./home page_adv_search.jpg": "92f0",
	"./how_it_works_1.jpg": "7a15",
	"./how_it_works_2.jpg": "6fff",
	"./how_it_works_3.jpg": "1fb6",
	"./human-avatar-color.svg": "8dee",
	"./human-avatar.png": "615b",
	"./human-avatar.svg": "f9cf",
	"./icon--facebook.svg": "aa7a",
	"./icon--google.svg": "125d",
	"./icon--instagram.svg": "c5b5",
	"./icon--linkedin.svg": "f2e1",
	"./icon--twitter.svg": "1c2c",
	"./info.png": "2226",
	"./login.jpg": "4424",
	"./login.png": "6d4b",
	"./logo-dark-1.svg": "9ce7",
	"./logo-dark.svg": "a599",
	"./logo-grey.svg": "20d3",
	"./logo-light.svg": "cf26",
	"./logo.svg": "1ae4",
	"./message_sent.svg": "807f",
	"./no_results.svg": "6247",
	"./notification.png": "0920",
	"./p-badge-junior_lib.png": "138c",
	"./p-badge-librarian.png": "dcb9",
	"./p-badge-master_lib.png": "1603",
	"./p-badge-new_lib.png": "ba51",
	"./p-badge-senior_lib.png": "3c97",
	"./profile-photo.jpg": "5821",
	"./r-badge-bronze.png": "05eb",
	"./r-badge-diamond.png": "d387",
	"./r-badge-gold.png": "dbc6",
	"./r-badge-member.png": "4ecf",
	"./r-badge-new.png": "9e51",
	"./r-badge-platinum.png": "e685",
	"./r-badge-senior.png": "cd55",
	"./r-badge-silver.png": "51d0",
	"./rating-categories/emotion.svg": "77f3",
	"./rating-categories/originality.svg": "1ad9",
	"./rating-categories/plot.svg": "0159",
	"./rating-categories/writingStyle.svg": "1333",
	"./review-empty-1.svg": "dd5f",
	"./review-empty-lg.svg": "07f2",
	"./review-empty-md.svg": "fb17",
	"./review-empty-xl.svg": "cbe1",
	"./review-empty.svg": "88f4",
	"./review-full-1.svg": "4f3b",
	"./review-full-lg.svg": "343f",
	"./review-full-md.svg": "32cc",
	"./review-full-xl.svg": "714d",
	"./review-full.svg": "ffbe",
	"./review_created.svg": "f20b",
	"./ribbon-bronze.jpg": "7391",
	"./ribbon-gold.jpg": "7317",
	"./ribbon-platinum.jpg": "0800",
	"./ribbon-silver.jpg": "f622",
	"./screen_adaptation_add.svg": "430b",
	"./search.svg": "6f6b",
	"./search_no_results.jpg": "b39c",
	"./share.png": "cff1",
	"./signature-1.jpg": "4e2a",
	"./signature-2.jpg": "856c",
	"./signup.jpg": "c962",
	"./small_page_books beach.jpg": "f210",
	"./star-empty-1.svg": "b893",
	"./star-empty.svg": "63bd",
	"./star-filled.svg": "aaff",
	"./star-full.svg": "9596",
	"./tag-close.svg": "5b6e",
	"./testimonials.png": "b60d",
	"./thank_you_page.jpg": "772a",
	"./upload-cloud.png": "ce4a",
	"./upload_avatar_icon.svg": "446a",
	"./user_registered.svg": "e9e9",
	"./we_need_you.png": "6cec",
	"./wisdom.png": "1a4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";